
import {UIGamePauseController} from '../../../shared/scripts/ui_game/UIGamePauseController'
import {GameFont} from '../../../shared/scripts/GameFont'

export class UIWGamePauseController extends UIGamePauseController {
    protected initializePlacementRatios() {
        this.BUTTON_CONTAINER_WIDTH_RATIO = 1 / 4
        this.BUTTON_CONTAINER_HEIGHT_RATIO = 1 / 12
        this.BUTTON_CONTAINER_Y_RATIO = 2 / 3

        this.TITLE_FONT_SIZE = GameFont.Size.Giant
        this.TITLE_Y_PLACEMENT = 0.85

        this.TIMER_Y_PLACEMENT = 1.85
        this.TIMER_FONT_SIZE = GameFont.Size.XXL
    }
}
